import { Box, Typography, FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'packages/eid-ui'
import { StartDateTimePicker } from 'components/TimeConstrainedControl/StartDateTimePicker'
import { EndDateTimePicker } from 'components/TimeConstrainedControl/EndDateTimePicker'

const StyledBox = styled(Box)(({ theme }) => ({
    '& h2': {
        fontSize: '1.8rem',
        color: '#1b1f1f',
        fontWeight: '600',
    },
}))

const AssignmentModalHeading = styled(Box)(({ theme }) => ({
    padding: '1.6rem 3.2rem',
    borderTop: '1px solid #0000002e !important',
    borderBottom: '1px solid #0000002e !important',
    backgroundImage:
        'linear-gradient(0deg, rgb(0, 0, 0, 0.02) 12.5%, rgb(255, 255, 255) 12.5%, rgb(255, 255, 255) 50%, rgb(0, 0, 0, 0.02) 50%, rgb(0, 0, 0, 0.02) 62.5%, rgb(255, 255, 255) 62.5%, rgb(255, 255, 255) 100%) !important',
    backgroundSize: '0.8rem 0.8rem !important',
}))

const AssignmentModalFooter = styled(Box)(({ theme }) => ({
    padding: '2.4rem 3.2rem',
    boxShadow: '0 0.3rem 0.7rem 0.4rem rgba(0, 0, 0, 0.08)',
    '& button': {
        border: `solid 1px ${theme.palette.primary.main}`,
        padding: '0.9rem 2.4rem',
        '&:nth-of-type(1)': {
            background: theme.palette.primary.main,
            color: '#fff',
            maxWidth: '24rem',
            '& svg': {
                marginRight: '1.5rem',
            },
        },
        '&:nth-of-type(2)': {
            color: theme.palette.primary.main,
            marginLeft: '3rem',
            maxWidth: '9rem',
        },
    },
}))

const AssignmentTimeInner = styled(Box)({
    padding: '0 3.2rem 2rem',
    '& .textfield': {
        maxWidth: '14rem !important',
    },
})

const TimeConstraintComp = ({
    handleEndDate,
    handleStartDate,
    selectedStartDate,
    selectedEndDate,
    hasInvalidDates,
    validationMessage,
    timeConstrained,
    handleTimeConstraint,
    maxEndDate
}) => {
    const { t } = useTranslation()

    return (
        <StyledBox
            sx={{
                boxShadow: '0 0.3rem 0.7rem 0.4rem rgba(0, 0, 0, 0.08)',
            }}
        >
            <Box sx={{ padding: '2rem 3.2rem' }}>
                <Box marginLeft="2rem">
                    <FormControlLabel
                        onChange={() => handleTimeConstraint(!timeConstrained)}
                        control={<Checkbox checked={timeConstrained} />}
                        label={t('TemporaryAccessGMTUTCTime')}
                    />
                </Box>
            </Box>
            <Box>
                {timeConstrained && (
                    <AssignmentTimeInner>
                        <Box display="flex" alignItems="center">
                            <Typography
                                sx={{
                                    marginRight: '2rem',
                                    fontSize: '1.4rem',
                                    color: '#5d6870',
                                    width: '10rem',
                                }}
                            >
                                {t('AccessBegins')}:
                            </Typography>
                            <StartDateTimePicker
                                selectedStartDate={selectedStartDate}
                                setSelectedStartDate={handleStartDate}
                            />
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            marginTop="2rem"
                        >
                            <Typography
                                sx={{
                                    marginRight: '2rem',
                                    fontSize: '1.4rem',
                                    color: '#5d6870',
                                    width: '10rem',
                                }}
                            >
                                {t('AccessEnds')}:
                            </Typography>
                            <EndDateTimePicker
                                selectedEndDate={selectedEndDate}
                                setSelectedEndDate={handleEndDate}
                                maxEndDate={maxEndDate}
                            />
                        </Box>
                        {hasInvalidDates && validationMessage && (
                            <Box
                                sx={{
                                    marginLeft: '12rem',
                                    fontSize: '1.2rem',
                                    color: (theme) => theme.palette.error.main,
                                    width: '50% !important',
                                }}
                            >
                                {validationMessage}
                            </Box>
                        )}
                    </AssignmentTimeInner>
                )}
            </Box>
        </StyledBox>
    )
}

export default TimeConstraintComp
